// /dev/mailbox (development only): the magic-link emails the server would have sent.
import { useEffect, useState } from "react";
import { api } from "../api";
import { useTitle } from "../lib/router";

interface Mail {
  id: number;
  to: string;
  subject: string;
  text: string;
  at: number;
}

export function DevMailbox() {
  useTitle("Dev mailbox");
  const [mails, setMails] = useState<Mail[] | null>(null);
  const [error, setError] = useState("");
  useEffect(() => {
    const load = () =>
      api<{ mails: Mail[] }>("GET", "/api/dev/mailbox")
        .then((r) => setMails(r.mails))
        .catch(() => setError("The dev mailbox only exists in development."));
    void load();
    const id = setInterval(load, 2000);
    return () => clearInterval(id);
  }, []);
  return (
    <main id="main" className="page">
      <h1>Dev mailbox</h1>
      <p className="muted">Development only: mail the server would send. Nothing leaves this machine.</p>
      {error && <p role="alert">{error}</p>}
      {mails?.length === 0 && <p>No mail yet.</p>}
      <ul className="mailbox">
        {mails?.map((m) => (
          <li key={m.id} className="panel" data-testid="mail">
            <p>
              <strong>{m.subject}</strong> → {m.to} <span className="muted">{new Date(m.at).toLocaleTimeString()}</span>
            </p>
            <pre className="mail-text">
              {m.text.split(/(https?:\/\/\S+)/).map((part, i) =>
                /^https?:\/\//.test(part) ? (
                  <a key={i} href={part.replace(/^https?:\/\/[^/]+/, "")} data-testid="mail-link">
                    {part}
                  </a>
                ) : (
                  part
                ),
              )}
            </pre>
          </li>
        ))}
      </ul>
    </main>
  );
}
